import { useCallback } from 'react';
import { createGlobalState } from 'react-use';

const initialState = {
	ExhibitionInfo: false,
	ExhibitorList: false,
	MyFavourites: false,
	ExhibitorInfo: false,
	SearchPanel: false,
	MobileMenu: false,
};

const useUIState = createGlobalState(initialState);

const useUI = () => {
	const [UIState, setUIState] = useUIState();

	const closeAllUI = useCallback(() => {
		setUIState(initialState);
	}, [setUIState]);

	const toggleUI = useCallback((UIName) => {
		setUIState({
			...initialState,
			[UIName]: !UIState[UIName],
		});
	}, [UIState, setUIState]);

	const toggleExhibitorInfo = useCallback(() => {
		setUIState((state) => {
			return {
				...state,
				ExhibitorList: false,
				ExhibitorInfo: !UIState.ExhibitorInfo,
			}
		});
	}, [UIState.ExhibitorInfo, setUIState]);

	const toggleSearchPanel = useCallback(() => {
		setUIState((state) => {
			return {
				...state,
				SearchPanel: !UIState.SearchPanel,
			}
		});
	}, [UIState.SearchPanel, setUIState]);

	return { ...UIState, closeAllUI, toggleUI, toggleExhibitorInfo, toggleSearchPanel };
}
export default useUI;